import types from "../types";

const initialState = [];

function categoriesReducer(state = initialState, { type, payload }) {
  switch (type) {
    case types.STORE_CATEGORIES:
      return payload;

    case types.CREATE_CATEGORY:
      return [...state, payload.data];

    case types.EDIT_CATEGORY:
      return state.map((category) => {
        if (category.id === payload.id) return payload;
        return category;
      });

    case types.DESTROY_CATEGORY:
      return state.filter((category) => category.id !== payload);

    default:
      return state;
  }
}

export default categoriesReducer;
